import { atom } from 'recoil';

export const isMentorState = atom({
    key: 'isMentorState',
    default: false,
});
